export default __webpack_public_path__ + "static/media/cpu-24.4a8f53fe.svg";